var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-2"},[_c('v-btn',{attrs:{"fab":"","small":"","dark":"","color":"error"},on:{"click":_vm.logout}},[_c('v-icon',{attrs:{"dark":"","rigth":""}},[_vm._v("mdi-power-standby")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }